var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAndroid = function SvgIconAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "m7.825 2.423 1.161-1.17a.4.4 0 1 0-.57-.564l-1.29 1.306A4.7 4.7 0 0 0 5 1.477c-.768 0-1.481.193-2.119.518L1.584.688a.401.401 0 1 0-.57.566l1.161 1.169A4.81 4.81 0 0 0 .2 6.31c0 .38.31.69.69.69h8.22a.69.69 0 0 0 .69-.69c0-1.602-.782-3.01-1.975-3.887M2.943 5.619a.69.69 0 0 1 0-1.38.69.69 0 0 1 0 1.38m4.114 0a.69.69 0 0 1 0-1.38.69.69 0 0 1 0 1.38"
  })));
};
export default SvgIconAndroid;